let lenis;
if (typeof Lenis !== 'undefined') {
  // Initialize Lenis
lenis = new Lenis();

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

const getThreshold = () => {
  const isHomepage = window.location.pathname === '/';
  return isHomepage ? window.innerHeight : window.innerHeight * 0.78;
};

let threshold = getThreshold();

window.addEventListener('resize', () => {
  threshold = getThreshold();
});

  lenis.on('scroll', ({ scroll }) => {
    if (isMenuOpen) return;
  
    header.classList.toggle(
      'header--scrolled',
      scroll > threshold
    );
  });
}

const menuToggle = document.querySelector('.header__menu-btn');
const headerMenu = document.getElementById('headerMenu');
const header = document.getElementById('header');
const menuLinks = document.querySelectorAll('.header__menu-list a');
const hamburgerTop = document.querySelector('.hamburger__bar--top');
const hamburgerBottom = document.querySelector('.hamburger__bar--bottom');

const menuText = document.querySelector('.header__menu-text');

let isMenuOpen = false;
let menuTimeline;
let wasScrolledBeforeOpen = false;

function createMenuTimeline() {
  if (menuTimeline) return menuTimeline;

  gsap.set('.header__menu-list li', {
    opacity: 0,
    y: 30,
  });
  gsap.set('.close-label', {
    opacity: 0,
    y: 10,
  });
  gsap.set('.header__menu-footer, .header__enquire-btn--menu', {
    opacity: 0,
    y: 20,
  });

  menuTimeline = gsap.timeline({
    paused: true,

    onStart: () => {
      headerMenu.style.pointerEvents = 'auto';
    },

    onReverseComplete: () => {
      headerMenu.style.pointerEvents = 'none';
    },
  });

  /*
   * Hamburger → X
   */

  menuTimeline.to(
    hamburgerTop,
    {
      rotate: 45,
      y: 4,
      duration: 0.4,
      ease: 'power2.inOut',
    },
    0
  );

  menuTimeline.to(
    hamburgerBottom,
    {
      rotate: -45,
      y: -4,
      duration: 0.4,
      ease: 'power2.inOut',
    },
    0
  );
  menuTimeline
  .to('.menu-label', {
    opacity: 0,
    y: -10,
    duration: 0.2,
  }, 0)

  .to('.close-label', {
    opacity: 1,
    y: 0,
    duration: 0.2,
  }, 0);
  

  /*
   * Dropdown Reveal
   */

  menuTimeline.to(
    headerMenu,
    {
      clipPath:
        'polygon(0% 0%,100% 0%,100% 100%,0% 100%)',
      duration: 0.8,
      ease: 'power4.inOut',
    },
    0
  );

  /*
   * Links
   */

  menuTimeline.to(
    '.header__menu-list li',
    {
      opacity: 1,
      y: 0,
      stagger: 0.08,
      duration: 0.5,
      ease: 'power3.out',
    },
    0.45
  );

  /*
   * Footer + CTA
   */

  menuTimeline.to(
    '.header__menu-footer, .header__enquire-btn--menu',
    {
      opacity: 1,
      y: 0,
      duration: 0.5,
      ease: 'power3.out',
    },
    0.6
  );

  return menuTimeline;
}
function openMenu() {
  isMenuOpen = true;
  createMenuTimeline().timeScale(1).play();
  wasScrolledBeforeOpen = header.classList.contains('header--scrolled');
  header.classList.remove('header--scrolled');
  lenis?.stop();
}

function closeMenu() {
  isMenuOpen = false;
  createMenuTimeline().timeScale(1.5).reverse();

  if (wasScrolledBeforeOpen) {
    header.classList.add('header--scrolled');
  }
  lenis?.start();
}

function toggleMenu() {
  isMenuOpen ? closeMenu() : openMenu();
}

menuToggle?.addEventListener('click', toggleMenu);

menuLinks.forEach((link) => {
  link.addEventListener('click', () => {
    closeMenu();
  });
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && isMenuOpen) {
    closeMenu();
  }
});



gsap.registerPlugin(ScrollTrigger, SplitText);

/*
|--------------------------------------------------------------------------
| Animation Utilities
|--------------------------------------------------------------------------
*/

function getDelay(el) {
  const value = window.innerWidth > 991 ? parseFloat(el.dataset.delay || 0) : 0.1;
  return value;
}

function getDuration(el, fallback = 0.8) {
  return parseFloat(el.dataset.duration || fallback);
}

let splitHeadingsData = [];

function prepareHeadings() {
  document.querySelectorAll('[data-animate="heading"]').forEach((heading) => {
    const split = SplitText.create(heading, {
      type: 'lines,words',
      linesClass: 'line',
    });

    
    gsap.set(split.words, {
      y: 20,
      opacity: 0,
    });

    
    splitHeadingsData.push({ heading, words: split.words });
  });
}

function setInitialStates() {
  // Fades
  gsap.set('[data-animate="fade-left"]', { x: -80, opacity: 0 });
  gsap.set('[data-animate="fade-right"]', { x: 80, opacity: 0 });
  gsap.set('[data-animate="fade-up"], [data-animate-group="fade-up"] > *', { y: 24, opacity: 0 });
  
  // Scales
  gsap.set('[data-animate="scale-up"]', { scale: 0.95, opacity: 0 });
  
  // Reveals
  gsap.set('[data-animate="reveal-left"]', { clipPath: 'inset(0 100% 0 0)' });
  gsap.set('[data-animate="reveal-right"]', { clipPath: 'inset(0 0 0 100%)' });
}

setInitialStates();
prepareHeadings();

function initAnimations() {

  /*
  |--------------------------------------------------------------------------
  | Split Heading
  |--------------------------------------------------------------------------
  */

  splitHeadingsData.forEach(({ heading, words }) => {
    gsap.to(words, {
      y: 0,
      opacity: 1,
      stagger: 0.03,
      duration: getDuration(heading, 0.8),
      delay: getDelay(heading),
      ease: 'power3.out',
      scrollTrigger: {
        trigger: heading,
        start: () => window.innerWidth < 991 ? "top 95%" : "top 85%",
        once: true,
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | Fades
  |--------------------------------------------------------------------------
  */
    
  gsap.utils
  .toArray('[data-animate="fade-left"]')
  .forEach((el) => {

    gsap.to(el, {
      x: 0,
      opacity: 1,
      duration: getDuration(el, 1),
      delay: getDelay(el),
      ease: 'power3.out',
      scrollTrigger: {
        trigger: el,
        start: () => window.innerWidth < 991 ? "top 95%" : "top 85%",
        once: true,
      },
    });
  });

gsap.utils
  .toArray('[data-animate="fade-right"]')
  .forEach((el) => {

    gsap.to(el, {
      x: 0,
      opacity: 1,
      duration: getDuration(el, 1),
      delay: getDelay(el),
      ease: 'power3.out',
      scrollTrigger: {
        trigger: el,
        start: () => window.innerWidth < 991 ? "top 95%" : "top 85%",
        once: true,
      },
    });
  });

  gsap.utils
    .toArray('[data-animate="fade-up"]')
    .forEach((el) => {

      gsap.to(el, {
        y: 0,
        opacity: 1,
        duration: getDuration(el, 0.8),
        delay: getDelay(el),
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: () => window.innerWidth < 991 ? "top 95%" : "top 90%",
          once: true,
        },
      });
    });

  /*
  |--------------------------------------------------------------------------
  | Scale Up
  |--------------------------------------------------------------------------
  */

  gsap.utils
    .toArray('[data-animate="scale-up"]')
    .forEach((el) => {

      gsap.to(el, {
        scale: 1,
        opacity: 1,
        duration: getDuration(el, 0.8),
        delay: getDelay(el),
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: () => window.innerWidth < 991 ? "top 95%" : "top 85%",
          once: true,
        },
      });
    });

  /*
  |--------------------------------------------------------------------------
  | Reveal Left
  |--------------------------------------------------------------------------
  */

  gsap.utils
    .toArray('[data-animate="reveal-left"]')
    .forEach((el) => {

      gsap.set(el, {
        clipPath: 'inset(0 100% 0 0)',
      });

      gsap.to(el, {
        clipPath: 'inset(0 0% 0 0)',
        duration: getDuration(el, 1),
        delay: getDelay(el),
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: () => window.innerWidth < 991 ? "top 95%" : "top 85%",
          once: true,
        },
      });
    });

  /*
  |--------------------------------------------------------------------------
  | Reveal Right
  |--------------------------------------------------------------------------
  */

  gsap.utils
    .toArray('[data-animate="reveal-right"]')
    .forEach((el) => {

      gsap.set(el, {
        clipPath: 'inset(0 0 0 100%)',
      });

      gsap.to(el, {
        clipPath: 'inset(0 0 0 0)',
        duration: getDuration(el, 1),
        delay: getDelay(el),
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: () => window.innerWidth < 991 ? "top 95%" : "top 85%",
          once: true,
        },
      });
    });

  /*
  |--------------------------------------------------------------------------
  | Stagger Group
  |--------------------------------------------------------------------------
  */

  document
    .querySelectorAll('[data-animate-group="fade-up"]')
    .forEach((group) => {

      gsap.to(group.children, {
        y: 0,
        opacity: 1,
        stagger: 0.15,
        duration: getDuration(group, 0.8),
        delay: getDelay(group),
        ease: 'power3.out',
        scrollTrigger: {
          trigger: group,
          start: () => window.innerWidth < 991 ? "top 95%" : "top 85%",
          once: true,
        },
      });
    });
}

gsap.utils.toArray('.counter').forEach((counter) => {

  ScrollTrigger.create({
    trigger: counter,
    start: 'top 90%',
    once: true,

    onEnter: () => {

      const obj = { value: 0 };

      gsap.to(obj, {

        value: Number(counter.dataset.count),

        duration: 2,

        ease: 'power2.out',

        onUpdate() {
          counter.textContent =
            Math.floor(obj.value);
        },

      });

    },

  });

});
/*
|--------------------------------------------------------------------------
| Hero
|--------------------------------------------------------------------------
*/

const hero = document.querySelector('.home-hero');
const media = document.querySelector('.home-hero__media');
const content = document.querySelector('.home-hero__content');

if (hero) {

  gsap.to(media, {
    scale: 1.5,
    ease: 'none',
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: 'bottom 50%',
      scrub: true,
    },
  });

  gsap.to(content, {
    y: -200,
    ease: 'none',
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: 'bottom 50%',
      scrub: true,
    },
  });
}

/*
|--------------------------------------------------------------------------
| Heritage Stack
|--------------------------------------------------------------------------
*/

const stack = document.querySelector('.heritage-stack');
const middleImage = stack?.querySelector('.heritage-stack__image--2');

if (stack && middleImage) {

  let expanded = false;
  let floatTween;

  function startFloat() {

    floatTween?.kill();

    floatTween = gsap.to(middleImage, {
      y: -20,
      duration: 1.5,
      ease: 'expo.inOut',
      repeat: -1,
      yoyo: true,
    });
  }

  startFloat();

  const expandTl = gsap.timeline({
    paused: true,

    onStart: () => {
      floatTween?.pause();
    },

    onReverseComplete: () => {
      startFloat();
    },
  });

  expandTl

    .to(middleImage, {
      yPercent: -100,
      rotation: 1.5,
      duration: 0.45,
      ease: 'power2.out',
    })

    .to(middleImage, {
      yPercent: 0,
      scale: 1.25,
      rotation: 0,
      zIndex: 20,
      duration: 0.6,
      ease: 'back.out(1.7)',
    });

  stack.addEventListener('click', () => {

    if (!expanded) {
      expandTl.play();
      expanded = true;
    } else {
      expandTl.reverse();
      expanded = false;
    }

  });
}

/*
|--------------------------------------------------------------------------
| Featured Highlights
|--------------------------------------------------------------------------
*/


// spaces-gallery.js
document.querySelectorAll('.spaces-gallery').forEach((section) => {
  const track   = section.querySelector('.spaces-gallery__track');
  const cards   = Array.from(track.querySelectorAll('.space-card'));
  const prevBtn = section.querySelector('.spaces-prev');
  const nextBtn = section.querySelector('.spaces-next');
  const total   = cards.length;

  const DURATION   = 1;
  const EASE       = 'power3.inOut';
  const SCALE_STEP = 0.13;
  const INACTIVE_BASIS = 'calc(6% - 4px)';
const BASIS_BY_DIST = window.innerWidth > 991
  ? ['calc(76% - 16px)', INACTIVE_BASIS, INACTIVE_BASIS, INACTIVE_BASIS, INACTIVE_BASIS]
  : ['calc(80% - 16px)', INACTIVE_BASIS, INACTIVE_BASIS, INACTIVE_BASIS, INACTIVE_BASIS];

  function getScale(dist) {
    return 1 - (dist * SCALE_STEP);
  }

  let current = cards.findIndex(c => c.classList.contains('is-active'));
  if (current === -1) current = Math.floor(total / 2);
  function updateNav() {
    prevBtn.classList.toggle('disabled', current === 0);
    nextBtn.classList.toggle('disabled', current === total - 1);
  }
  function init() {
    cards.forEach((card, i) => {
      const dist = Math.abs(i - current);
      gsap.set(card, {
        flexBasis: BASIS_BY_DIST[dist],
        scaleY: getScale(dist),
      });
    });
    updateNav();
  }

  function setActive(index) {
    index = Math.max(0, Math.min(total - 1, index));
    if (index === current) return;

    cards[current].classList.remove('is-active');
    cards[index].classList.add('is-active');

    cards.forEach((card, i) => {
      const dist = Math.abs(i - index);
      gsap.to(card, {
        flexBasis: BASIS_BY_DIST[dist],
        scaleY: getScale(dist),
        duration: DURATION,
        ease: EASE,
      });
    });

    current = index;
    updateNav();
  }

  cards.forEach((card, i) => {
    card.addEventListener('click', () => setActive(i));
  });

  prevBtn.addEventListener('click', () => setActive(current - 1));
  nextBtn.addEventListener('click', () => setActive(current + 1));

  init();
});

new Swiper('.featured-logos', {
  slidesPerView: 'auto',
  spaceBetween: 60,

  loop: true,
  freeMode: true,

  speed: 5000,

  allowTouchMove: false,

  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
});
/*
|--------------------------------------------------------------------------
| Init
|--------------------------------------------------------------------------
*/

 const preload = () => {
  window.scrollTo(0, 0);
  if (typeof lenis !== 'undefined') {
    lenis.scrollTo(0, { immediate: true });
    lenis.stop();
  }

  const tl = gsap.timeline({
    onComplete: () => {
      document.getElementById('preloader').style.display = 'none';
      initAnimations();
      lenis.start();
    }
  });

  
  tl.to(".preload-img", {
    clipPath: "inset(0% 0% 100% 0%)",
    duration: 0.8,
    ease: "power2.inOut",
    stagger: 0.6
  })
  
  
  .to("#preloader", {
    clipPath: "inset(0% 0% 100% 0%)",
    duration: 1,
    ease: "power4.inOut"
  }, "+=0.3");
}

const preloader = document.getElementById('preloader');


if(preloader){
  const hasSeenPreloader = sessionStorage.getItem('preloaderSeen');

  if (!hasSeenPreloader) {
    // First visit in this tab: run preloader and set the session flag
    sessionStorage.setItem('preloaderSeen', 'true');
    preload();
    
  } else {
    // Flag exists: instantly hide preloader and fire main animations
    preloader.style.display = 'none';
    initAnimations();
  }
}else{
  initAnimations();
}
function initTimelineAnimation() {
  const timelinecards = document.querySelectorAll('.timelinecard');

  
  if (timelinecards.length === 0) {
    return;
  }

  
  let mm = gsap.matchMedia();

  mm.add({
    isDesktop: "(min-width: 991px)",
    isMobile: "(max-width: 990px)"
  }, (context) => {
    
    let { isDesktop } = context.conditions;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.stickywrappertimeline',
        start: window.innerWidth > 991 ? 'top 40%' : 'top 70%',
        end: 'bottom bottom',
        scrub: 1.2,
      }
    });

    
    const cards = gsap.utils.toArray(timelinecards); 
    
    gsap.set('.card-dot', { opacity: 0 });

    const TOTAL = cards.length;
    
    tl.to('.bartimelinebar', { 
      [isDesktop ? 'scaleX' : 'scaleY']: 1, 
      ease: 'none', 
      duration: 1 
    }, 0);

    cards.forEach((card, i) => {
      const dot = card.querySelector('.card-dot');
      const dotAt = (i + 0.5) / TOTAL;
      const cardStart = Math.max(0, dotAt - 0.18);

      tl.to(card, { opacity: 1, y: 0, ease: 'power2.out', duration: dotAt - cardStart }, cardStart);
      tl.to(dot,  { opacity: 1, scale: 1, ease: 'back.out(2.5)', duration: 0.04 }, dotAt);
    });
  });
}


document.addEventListener("DOMContentLoaded", () => {
  initTimelineAnimation();
});